// @flow
import * as React from "react"
import Mobile from "components/Media/Mobile"
import Desktop from "components/Media/Desktop"
import DesktopLoggedOutNav from "./DesktopLoggedOutNav"
import MobileLoggedOutNav from "./MobileLoggedOutNav"
import { LoggedOutNavWrap } from "./styled"

const LoggedOutNav = () => (
  <LoggedOutNavWrap>
    <Mobile>
      <MobileLoggedOutNav />
    </Mobile>
    <Desktop>
      <DesktopLoggedOutNav />
    </Desktop>
  </LoggedOutNavWrap>
)

export default LoggedOutNav



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedOutNav/index.js